import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IAccessNotification } from '@obvious.tech/constellation'

export const AccessNotification = defineEntity('AccessNotification', {
  endpoint: 'accesscontrol/api/AccessNotification',
  schema: SNoop<IAccessNotification>(),
})
